module.exports = __webpack_public_path__ + "img/download-gray.1c700af2.svg";